<div class="text-right">
  <app-custom-button variant="primary" size="sm" icon="fas fa-plus" (btnClick)="openModal()" class="mb-2">
    {{ 'AbpIdentity::AddMember' | abpLocalization }}
  </app-custom-button>
</div>

<abp-extensible-table
  [data]="currentOrganizationUnits.items"
  [recordsTotal]="currentOrganizationUnits.totalCount"
  [list]="list"
  [actionsTemplate]="actions"
></abp-extensible-table>

<ng-template #actions let-rowData>
  <app-custom-button variant="danger" size="sm" icon="fa fa-trash" (btnClick)="delete(rowData.id, rowData.userName)">
  </app-custom-button>
</ng-template>

<abp-modal [(visible)]="isModalVisible" [busy]="isModalBusy">
  <ng-template #abpHeader>
    <h3>{{ 'AbpIdentity::SelectUsers' | abpLocalization }}</h3>
  </ng-template>

  <ng-template #abpBody>
    <app-ldm-organization-members-modal-body
      [checkedUnits]="checkedUnits"
      [isCheckboxDisabled]="isCheckboxDisabled"
    ></app-ldm-organization-members-modal-body>
  </ng-template>

  <ng-template #abpFooter>
    <app-custom-button variant="outline" size="md" (btnClick)="isModalVisible = false">
      {{ 'AbpIdentity::Cancel' | abpLocalization }}
    </app-custom-button>
    <app-custom-button variant="primary" size="md" [disabled]="isModalBusy" (btnClick)="addUnits()" >
      {{ 'AbpIdentity::Save' | abpLocalization }}
    </app-custom-button>
  </ng-template>
</abp-modal>
